// extracted by mini-css-extract-plugin
export default {"topBtn":"style_topBtn__TJHvA","arrow":"style_arrow__EQs6f"};